import { FormattedMessage, useIntl } from 'react-intl'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { useAppDispatch } from 'app/hooks'
import { commonMessages } from 'app/i18n/messages'
import ConfirmModal from 'components/Modal/ConfirmModal'
import { TextField } from 'components/Fields'

import { ClaimHomeMessage, ClaimHomeFormContent } from './styles'
import { claimHomeModalMessages } from './messages'
import { addHomeThunk } from 'features/jobs/slice'
import { DOMAIN_API_ERROR } from 'features/jobs/consts'

const schema = Yup.object().shape({
  claimCode: Yup.string().required(''),
  jobName: Yup.string().required(''),
})

interface ClaimHomeModalProps {
  domainId: string
  jobName?: string
  onClose: () => void
  onAddSuccess: ({ homeId }: { homeId: string }) => void
}

const ClaimHomeModal = ({
  domainId,
  onClose,
  onAddSuccess,
  jobName = '',
}: ClaimHomeModalProps) => {
  const { formatMessage } = useIntl()
  const dispatch = useAppDispatch()
  const hasExistingJob = !!jobName

  const initialValues = {
    claimCode: '',
    jobName,
  }

  // TODO Error localization
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={async ({ claimCode, jobName }, formProps) => {
        try {
          const { homeId } = await dispatch(
            addHomeThunk(
              hasExistingJob
                ? { claimCode, domainId }
                : { claimCode, jobName, domainId }
            )
          )
          onAddSuccess({ homeId })
          onClose()
        } catch (err: any) {
          console.log('Error claiming a home', err)

          if (err?.name === DOMAIN_API_ERROR.DOMAIN_JOB_EXISTS) {
            return formProps.setFieldError('jobName', err.message)
          }
          return formProps.setFieldError('claimCode', err?.message)
        }
      }}
    >
      {({ isSubmitting, submitForm }) => (
        <ConfirmModal
          isOpen
          onDiscard={onClose}
          title={<FormattedMessage {...claimHomeModalMessages.title} />}
          discardBtnTitle={<FormattedMessage {...commonMessages.cancel} />}
          confirmBtnTitle={
            <FormattedMessage {...claimHomeModalMessages.ctaBtn} />
          }
          onConfirm={() => submitForm()}
          variant="primary"
          isConfirmBtnDisabled={isSubmitting}
        >
          <ClaimHomeMessage>
            <FormattedMessage {...claimHomeModalMessages.msg} />
          </ClaimHomeMessage>

          <Form>
            <ClaimHomeFormContent>
              <TextField
                name="claimCode"
                inputId="claimCode"
                autoFocus
                placeholder={formatMessage(
                  claimHomeModalMessages.claimCodeInput
                )}
              />
              <TextField
                disabled={hasExistingJob}
                name="jobName"
                placeholder={formatMessage(claimHomeModalMessages.jobNameInput)}
              />
            </ClaimHomeFormContent>
          </Form>
        </ConfirmModal>
      )}
    </Formik>
  )
}

export default ClaimHomeModal
